import type { Tab } from '../../custom-tab-bar/type.d.ts';

export const route = {
  component: () => import('../../pages/heat/page.vue'),
  path: '/hotel/heat',
  name: 'hotel-heat',
  meta: {
    title: '加热控制',
    auth: true,
    needPhone: false,
    wechat: {
      AppMessageShare: false,
      TimelineShare: false,
      baseAuth: true,
    },
  },
};

export const tab: Tab = {
  label: route.meta.title,
  icon: 'fire-o',
  to: {
    name: route.name,
  },
};
